import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/api';
import Sidebar from '../../components/Sidebar';
import '../../styles/UsersListPage.css';
import '../../styles/DashboardLayout.css';

const UsersListPage = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState({ role: '', search: '' });
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Toggle sidebar
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Close sidebar
  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        
        // Get current user data from localStorage
        const userData = localStorage.getItem('user');
        const currentUser = userData ? JSON.parse(userData) : null;
        
        // Log current user info for debugging
        if (currentUser) {
          console.log('Current user role:', currentUser.role);
          console.log('Current user center:', currentUser.center);
        }
        
        const response = await api.get('/users', { 
          params: { 
            role: filter.role || undefined,
            search: filter.search || undefined
          } 
        });
        
        console.log('Users API response:', response.data);
        
        if (response.data) {
          // Handle different response formats
          const usersData = response.data.success ? response.data.data : response.data;
          
          // Log each user's center for debugging
          if (Array.isArray(usersData)) {
            usersData.forEach(user => {
              console.log(`User ${user.name} (${user.role}) - Center: ${user.center}`);
            });
          }
          
          setUsers(Array.isArray(usersData) ? usersData : []);
        } else {
          setUsers([]);
        }
      } catch (err) {
        console.error('Error fetching users:', err);
        setError('Failed to load users. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [filter]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter(prev => ({ ...prev, [name]: value }));
  };


  const getRoleBadgeClass = (role) => {
    switch (role) {
      case 'admin': return 'badge-admin';
      case 'teacher': return 'badge-teacher';
      case 'student': return 'badge-student';
      case 'parent': return 'badge-parent';
      case 'super_admin': return 'badge-super-admin';
      default: return 'badge-default';
    }
  };

  return (
    <div className="dashboard-container">
      {/* Mobile Header - without hamburger menu */}
      <div className="mobile-header">
        <h1 className="app-title">Users Management</h1>
        <div className="avatar">👤</div>
      </div>

      {/* Dashboard Layout */}
      <div className="dashboard-layout">
        {/* Sidebar */}
        <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
        
        {/* Main Content */}
        <div className="dashboard-content">
          <div className="users-list-container">
            <div className="header">
              <div className="header-left">
                <Link to="/dashboard" className="back-to-dashboard">
                  &larr; Back to Dashboard
                </Link>
                <h1>Users Management</h1>
              </div>
              <Link to="/users/new" className="create-user-btn">
                Create New User
              </Link>
            </div>

            <div className="filters-container">
              <div className="filter">
                <label htmlFor="role">Role:</label>
                <select 
                  id="role" 
                  name="role" 
                  value={filter.role} 
                  onChange={handleFilterChange}
                >
                  <option value="">All Roles</option>
                  <option value="admin">Admin</option>
                  <option value="teacher">Teacher</option>
                  <option value="student">Student</option>
                  <option value="parent">Parent</option>
                </select>
              </div>

              <div className="filter">
                <label htmlFor="search">Search:</label>
                <input 
                  type="text" 
                  id="search" 
                  name="search" 
                  value={filter.search} 
                  onChange={handleFilterChange}
                  placeholder="Search by name or email..."
                />
              </div>
            </div>

            {loading ? (
              <div className="loading">Loading users...</div>
            ) : error ? (
              <div className="error">{error}</div>
            ) : (
              <>
                <div className="users-count">
                  Showing {users.length} user{users.length !== 1 ? 's' : ''}
                </div>
                
                <div className="users-table-container">
                  <table className="users-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Role</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users.length > 0 ? (
                        users.map(user => (
                          <tr 
                            key={user._id} 
                            onClick={() => window.location.href = `/users/${user._id}/edit`}
                            className="clickable-row"
                          >
                            <td>{user.name}</td>
                            <td>{user.email}</td>
                            <td>
                              <span className={`role-badge ${getRoleBadgeClass(user.role)}`}>
                                {user.role}
                              </span>
                            </td>
                            <td>
                              <span className={`status-badge ${user.active ? 'status-active' : 'status-inactive'}`}>
                                {user.active ? 'Active' : 'Inactive'}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="no-results">
                            No users found matching your criteria
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}

          </div>

        </div>
      </div>
    </div>
  );
};

export default UsersListPage;